import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TppCommonService } from '@nspk/tpp-front-commons';
import { filter } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(
        private router: Router,
        private tppCommonService: TppCommonService
    ) {
    }

    ngOnInit(): void {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                console.log(event.url);
                if (event.url === '/') {
                    this.tppCommonService.setCookie('gsRequestError', true);
                    this.router.navigate(['/error']);
                }
            });
    }
}
